import styled from '@emotion/styled'
import tw from 'twin.macro'

export const BasketButton = styled.div`
  ${tw`
    flex
    justify-end
    items-center
  `}
    a {
      ${tw`
        inline-flex 
        items-center 
        justify-center
        text-base
        font-medium
        text-gray-900
        focus:outline-none
      `}
      svg {
        ${tw`
          h-6 
          w-auto 
          pl-2
          stroke-current 
          text-gray-900
        `}
      }
    }
  }
`
